import type { MealType } from '@/api/types/nutrition'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

import { isMealType, MEAL_TYPE_LABELS, MEAL_TYPE_ORDER } from './meal-types'

type Props = {
  value: MealType
  onValueChange: (value: MealType) => void
  triggerClassName?: string
  itemClassName?: string
  'aria-label'?: string
}

/** 食事の種別（朝食/昼食/夕食/間食）を選ぶ */
export function MealTypeSelect({
  value,
  onValueChange,
  triggerClassName,
  itemClassName,
  'aria-label': ariaLabel = '食事の種別',
}: Props) {
  return (
    <Select
      value={value}
      onValueChange={(next) => {
        if (isMealType(next)) onValueChange(next)
      }}
    >
      <SelectTrigger className={triggerClassName} aria-label={ariaLabel}>
        <SelectValue placeholder="種別" />
      </SelectTrigger>
      <SelectContent>
        {MEAL_TYPE_ORDER.map((type) => (
          <SelectItem key={type} value={type} className={itemClassName}>
            {MEAL_TYPE_LABELS[type]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
